import { Component, Input } from '@angular/core';
import {  InvestmentModelForInvestorTypeShort, InvestmentModelShort } from '../../../../shared/model/interfaces';


@Component({
  selector: 'app-portfolio-block',
  templateUrl: './portfolio-block.component.html',
  styleUrls: ['./portfolio-block.component.scss']
})
export class PortfolioBlockComponent {

  @Input() user: any;
  @Input() label = '';
  @Input() userInfo: {
    InActiveInvestments: InvestmentModelShort[] | InvestmentModelForInvestorTypeShort[],
    ActiveInvestments: InvestmentModelShort[] | InvestmentModelForInvestorTypeShort[],
    TotalInActiveCommitmentAmt: number,
    TotalInActiveCapitalAmt: number,
    TotalInActiveUnits: number,
    TotalInActiveValueAmt: number,
    TotalInActiveOrigCapitalAmt: number,
    TotalActiveCommitmentAmt: number,
    TotalActiveCapitalAmt: number,
    TotalActiveUnits: number,
    TotalActiveValueAmt: number,
    TotalActiveOrigCapitalAmt: number
  };
  @Input() differentLoggedIn: boolean;

  display = false;
  alertMessage: string;
  InboxCount = 0;


  onConfirm() {
    this.display = false;
  }


}
